<script>
	import { onMount } from "svelte";
	import { appVersionAll as all } from "../../stores";
	import { postApi as post, putApi as put, delApi as del } from "../../service/api";
	import { Dates } from "../../utils/date";
	import TableToolbar from "../../components/TableToolbar.svelte";
	import Pagination from "../../components/Pagination.svelte";
	import { menu, menuSub, menuSubSub } from "../../stores";
	import Tab from "../../components/Tab.svelte";

	// 상수 정의
	const BASE_URL = "/version/app";
	const PAGE_SIZES = [10, 15, 20, 25, 30, 50, 100];
	let pageSize = 10; // 페이지당 항목 수
	let totalItems = 0;

	// 상수 정의
	const TYPES = {
		ios: { value: "ios", text: "iOS" },
		aos: { value: "aos", text: "Android" },
	};

	const ACTIVE_OPTIONS = [
		{ value: true, text: "사용" },
		{ value: false, text: "미사용" },
	];

	const FORCE_OPTIONS = [
		{ value: true, text: "필수" },
		{ value: false, text: "선택" },
	];

	// 상태 관리
	let isEditMode = false;
	let editingRowId = null;
	let focusField = "versionCode";
	let activeTab = "all";
	let filteredData = [];

	// 페이징 상태
	let currentPage = 1;
	let totalPages = 1;

	// 편집 아이템 초기값
	const defaultEditItem = {
		id: 0,
		idService: 1,
		packageName: "com.sleepwave.formebuds.cn",
		versionName: "",
		versionCode: 0,
		description: "",
		isForce: false,
		isActive: false,
		effectiveAt: new Date().toISOString(),
		type: "aos",
	};

	let editItem = { ...defaultEditItem };

	const tabs = [
		{ key: "all", text: "전체 앱 버전" },
		{ key: "ios", text: "iOS" },
		{ key: "aos", text: "Android" },
	];

	// 메서드
	const setFocus = (field = "packageName") => {
		focusField = field;
	};

	const validateItem = () => {
		if (!editItem.packageName) {
			alert("패키지명을 입력하세요.");
			setFocus("packageName");
			return false;
		}
		if (!editItem.versionName) {
			alert("버전명을 입력하세요.");
			setFocus("versionName");
			return false;
		}
		if (!editItem.versionCode) {
			alert("버전 코드를 입력하세요.");
			setFocus("versionCode");
			return false;
		}
		return true;
	};

	const handleSave = async () => {
		if (!validateItem()) return;

		const payload = {
			...editItem,
			versionCode: parseInt(editItem.versionCode),
			isForce: Boolean(editItem.isForce),
			isActive: Boolean(editItem.isActive),
		};

		(await editItem.id) ? put(BASE_URL, payload) : post(BASE_URL, payload);

		await fnSearch();
	};

	const fnSearch = async () => {
		if (activeTab === "all") {
			await all.fetch(`${BASE_URL}/all/${pageSize}/${currentPage}`); // 전체 데이터 가져오기
		} else {
			await all.fetch(`${BASE_URL}/${activeTab}/${pageSize}/${currentPage}`); // 특정 탭 데이터 가져오기
		}
		resetEdit();
	};

	const resetEdit = () => {
		isEditMode = false;
		editingRowId = null;
		editItem = { ...defaultEditItem };
	};

	const fnProcessRegist = () => {
		if (!isEditMode) {
			// 마지막 데이터의 버전명과 버전코드 가져오기
			const lastItem = filteredData[0];
			const lastVersionName = lastItem?.versionName || "";
			const lastVersionCode = lastItem?.versionCode || 0;
			// 현재 탭에 맞는 플랫폼 타입 설정
			const currentType = activeTab === "all" ? "aos" : activeTab;

			isEditMode = true;
			editingRowId = null;
			editItem = {
				...defaultEditItem,
				type: currentType,
				versionName: lastVersionName,
				versionCode: lastVersionCode + 1,
				effectiveAt: new Date().toISOString().slice(0, 16),
			};
			focusFirstInput();
		}
	};

	const focusFirstInput = () => {
		setTimeout(() => {
			const versionCodeInput = document.querySelector('input[type="number"]');
			if (versionCodeInput) {
				versionCodeInput.focus();
				versionCodeInput.select();
			}
		});
	};

	const fnProcessEdit = (item) => {
		if (!isEditMode) {
			isEditMode = true;
			editingRowId = item.id;
			editItem = {
				...item,
				effectiveAt: item.effectiveAt.slice(0, 16),
			};
			focusFirstInput();
		}
	};

	const fnDelete = async (id) => {
		const item = $all.data.list.find((item) => item.id === id);
		if (item.isActive) {
			alert("사용 중인 앱 버전은 삭제할 수 없습니다.");
			return;
		}

		if (confirm("정말 삭제하시겠습니까?")) {
			await del(BASE_URL, { id });
			await fnSearch();
		}
	};

	const fnRegistServer = () => {
		if (confirm("서버에 적용하시겠습니까?")) {
			put(`${BASE_URL}/cache`, {}).then((success) => {
				if (success) {
					alert("서버 적용이 완료되었습니다.");
					fnSearch();
				}
			});
		}
	};

	// 탭 변경 핸들러
	const handleTabClick = (tab) => {
		activeTab = tab;
		fnSearch();
	};

	const handlePageSizeChange = (event) => {
		pageSize = parseInt(event.target.value); // pageSize 값 업데이트
		currentPage = 1; // 페이지를 1로 리셋
		fnSearch(); // 목록 새로고침
	};

	// 페이지 변경 핸들러
	const handlePageChange = (page) => {
		if (page < 1 || page > totalPages) return;
		currentPage = page;
		fnSearch();
	};

	$: {
		const data = $all?.data || {};
		filteredData = data.list || [];
		totalPages = Math.ceil((data.total || 0) / pageSize);
		totalItems = data.total || 0;
	}

	onMount(() => {
		menu.set("버전 관리");
		menuSub.set("앱 버전");
		menuSubSub.set("");
		fnSearch();
	});
</script>

<div class="card mb-4">
	<div class="table-responsive text-nowrap">
		<Tab {tabs} {activeTab} onTabChange={handleTabClick} />
		<div class="ms-auto" style="padding: 5px;">
			<TableToolbar
				{totalItems}
				{currentPage}
				{totalPages}
				{pageSize}
				pageSizes={PAGE_SIZES}
				onPageSizeChange={handlePageSizeChange}
				onReload={fnSearch}
				onRegist={fnProcessRegist}
				onRegistServer={fnRegistServer}
			/>
		</div>
		<div class="fade-container {activeTab ? 'show' : ''}">
			<!-- 메인 테이블 -->
			<table class="table small">
				<thead>
					<tr style="text-align:center">
						<th width="80">No</th>
						<th width="130">서비스</th>
						<th width="200">패키지명</th>
						<th width="100">버전명</th>
						<th width="100">버전코드</th>
						<th width="*">설명</th>
						<th width="100">필수 여부</th>
						<th width="100">사용 여부</th>
						<th width="130">유효일시</th>
						<th width="130">적용일시</th>
						<th width="130">등록일시</th>
						<th width="130">수정일시</th>
						<th width="130">관리</th>
					</tr>
				</thead>
				<tbody>
					{#if isEditMode && !editingRowId}
						<tr style="text-align:center">
							<td />
							<td>
								<select class="form-select form-select-sm" bind:value={editItem.type}>
									{#each Object.values(TYPES) as { value, text }}
										<option {value}>{text}</option>
									{/each}
								</select>
							</td>
							<td>
								<input
									type="text"
									class="form-control form-control-sm"
									style="text-align: center"
									bind:value={editItem.packageName}
									on:focus={() => setFocus("packageName")}
								/>
							</td>
							<td>
								<input
									type="text"
									class="form-control form-control-sm"
									style="text-align: center"
									bind:value={editItem.versionName}
									on:focus={() => setFocus("versionName")}
								/>
							</td>
							<td>
								<input
									type="number"
									class="form-control form-control-sm"
									style="text-align: center"
									bind:value={editItem.versionCode}
									on:focus={() => setFocus("versionCode")}
								/>
							</td>
							<td>
								<input
									type="text"
									class="form-control form-control-sm"
									style="text-align: center"
									bind:value={editItem.description}
									on:focus={() => setFocus("description")}
								/>
							</td>
							<td>
								<div class="form-check form-switch d-flex justify-content-center">
									<input class="form-check-input" type="checkbox" id="isForce-new" bind:checked={editItem.isForce} />
								</div>
							</td>
							<td>
								<div class="form-check form-switch d-flex justify-content-center">
									<input class="form-check-input" type="checkbox" id="isActive-new" bind:checked={editItem.isActive} />
								</div>
							</td>
							<td>
								<input type="datetime-local" class="form-control form-control-sm" bind:value={editItem.effectiveAt} />
							</td>
							<td />
							<td />
							<td />
							<td>
								<button class="btn btn-sm btn-primary me-1" on:click={handleSave}>Save</button>
								<button class="btn btn-sm btn-outline-secondary" on:click={resetEdit}>Cancel</button>
							</td>
						</tr>
					{/if}

					{#each filteredData as item, index}
						{#if editingRowId === item.id}
							<tr style="text-align:center">
								<td>{totalItems - ((currentPage - 1) * pageSize + index)}</td>
								<td>
									<select class="form-select form-select-sm" bind:value={editItem.type}>
										{#each Object.values(TYPES) as { value, text }}
											<option {value}>{text}</option>
										{/each}
									</select>
								</td>
								<td>
									<input
										type="text"
										class="form-control form-control-sm"
										style="text-align: center"
										bind:value={editItem.packageName}
										on:focus={() => setFocus("packageName")}
									/>
								</td>
								<td>
									<input
										type="text"
										class="form-control form-control-sm"
										style="text-align: center"
										bind:value={editItem.versionName}
										on:focus={() => setFocus("versionName")}
									/>
								</td>
								<td>
									<input
										type="number"
										class="form-control form-control-sm"
										style="text-align: center"
										bind:value={editItem.versionCode}
										on:focus={() => setFocus("versionCode")}
									/>
								</td>
								<td>
									<input
										type="text"
										class="form-control form-control-sm"
										style="text-align: center"
										bind:value={editItem.description}
										on:focus={() => setFocus("description")}
									/>
								</td>
								<td>
									<div class="form-check form-switch d-flex justify-content-center">
										<input class="form-check-input" type="checkbox" id="isForce-edit" bind:checked={editItem.isForce} />
									</div>
								</td>
								<td>
									<div class="form-check form-switch d-flex justify-content-center">
										<input class="form-check-input" type="checkbox" id="isActive-edit" bind:checked={editItem.isActive} />
									</div>
								</td>
								<td>
									<input type="datetime-local" class="form-control form-control-sm" bind:value={editItem.effectiveAt} />
								</td>
								<td>{Dates.defaultConvertFull(item.applyAt)}</td>
								<td>{Dates.defaultConvertFull(item.createdAt)}</td>
								<td>{Dates.defaultConvertFull(item.updatedAt)}</td>
								<td>
									<button class="btn btn-sm btn-primary me-1" on:click={handleSave}>Save</button>
									<button class="btn btn-sm btn-outline-secondary" on:click={resetEdit}>Cancel</button>
								</td>
							</tr>
						{:else}
							<tr style="text-align:center">
								<td>{totalItems - ((currentPage - 1) * pageSize + index)}</td>
								<td>
									<span class="badge {item.type === 'ios' ? 'bg-primary' : 'bg-success'}">
										{Object.values(TYPES).find((t) => t.value === item.type)?.text || item.type}
									</span>
								</td>
								<td>{item.packageName}</td>
								<td>{item.versionName}</td>
								<td>{item.versionCode}</td>
								<td>{item.description}</td>
								<td>
									<div class="form-check form-switch d-flex justify-content-center">
										<input class="form-check-input" type="checkbox" checked={item.isForce} disabled readonly />
									</div>
								</td>
								<td>
									<div class="form-check form-switch d-flex justify-content-center">
										<input class="form-check-input" type="checkbox" checked={item.isActive} disabled readonly />
									</div>
								</td>
								<td>{Dates.defaultConvertFull(item.effectiveAt)}</td>
								{#if item.applyAt != "0001-01-01T00:00:00Z"}
									<td style="color: #0000FF;">{Dates.defaultConvertFull(item.applyAt)}</td>
								{:else}
									<td>미적용</td>
								{/if}
								<td>{Dates.defaultConvertFull(item.createdAt)}</td>
								<td>{Dates.defaultConvertFull(item.updatedAt)}</td>
								<td>
									<button class="btn btn-sm btn-outline-primary me-1" on:click={() => fnProcessEdit(item)}>Edit</button>
									<button class="btn btn-sm btn-outline-primary" on:click={() => fnDelete(item.id)}>Delete</button>
								</td>
							</tr>
						{/if}
					{/each}
				</tbody>
			</table>
		</div>
		<Pagination {currentPage} {totalPages} onPageChange={handlePageChange} />
	</div>
</div>

<style>
	.fade-container {
		opacity: 0;
		transition: opacity 0.15s linear;
	}

	.fade-container.show {
		opacity: 1;
	}

	table {
		width: 100%; /* 테이블 너비를 100%로 설정 */
		border-collapse: collapse; /* 테이블 경계 겹침 방지 */
	}
	th,
	td {
		padding: 8px; /* 셀 패딩 추가 */
		text-align: left; /* 텍스트 정렬 */
		border: 1px solid #ddd; /* 셀 경계 추가 */
	}
</style>
